export default __webpack_public_path__ + "static/media/company_logo.d9ec0e48.svg";